import { render } from "./projects-form-location.vue?vue&type=template&id=35d7cf08"
import script from "./projects-form-location.vue?vue&type=script&lang=js"
export * from "./projects-form-location.vue?vue&type=script&lang=js"

import "./projects-form-location.vue?vue&type=style&index=0&id=35d7cf08&lang=scss"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__